module fdm.flightSegment {

    var cruiseReportMediaType = 'application/octet-stream';

    function findCruisePerformanceExportLink($filter: dgUtils.IFilterService, query: any): dg.restfulApi.Link {
        if (!query || !query.dgMeta || !query.dgMeta.links) {
            return null;
        }
        var links = $filter('dgLinksByRel')(query.dgMeta.links, [dg.restfulApi.DG_LINK_RELS.export, dg.restfulApi.DG_LINK_RELS.external]);
        for (var i = 0; i < links.length; i++) {
            var l = links[i];
            if (l.mediaType === cruiseReportMediaType && l.title === 'Cruise performance' && !l.disabledReason) {
                return l;
            }
        }
        return null;
    }

    angular.module('fdm.flightSegment').directive('cruisePerformanceExport', ['$uibModal', '$filter',
        function ($uibModal: ng.ui.bootstrap.IModalService, $filter: dgUtils.IFilterService) {
            return {
                restrict: 'E',
                scope: {
                    query: '<'
                },
                link: function (scope: any, element: ng.IAugmentedJQuery) {
                    var toolbar: ng.IAugmentedJQuery = null;
                    var cruiseBtn: ng.IAugmentedJQuery = null;

                    var removeButton = function () {
                        if (cruiseBtn) {
                            cruiseBtn.remove();
                            cruiseBtn = null;
                        }
                    };

                    var openCruisePerformanceModal = function (link: dg.restfulApi.Link) {
                        var seedQuery = scope.query
                            ? <dg.domain.IDomainObject>dgUtils.ObjectHelperService.mergeDeep({}, scope.query)
                            : null;

                        $uibModal.open({
                            controller: 'CruisePerformanceExportModalController',
                            templateUrl: '/app/src/flight-segment/cruise-performance-export-modal.html',
                            size: 'lg',
                            backdrop: 'static',
                            resolve: {
                                exportLink: function () { return angular.extend({}, link); },
                                seedQuery: function () { return seedQuery; }
                            }
                        });
                    };

                    var syncButton = function () {
                        removeButton();
                        var cruiseLink = findCruisePerformanceExportLink($filter, scope.query);
                        if (!cruiseLink) {
                            return;
                        }
                        if (!toolbar || !toolbar.length) {
                            toolbar = angular.element(document.querySelector('.view-heading .dg-exports-toolbar'));
                        }
                        if (!toolbar || !toolbar.length) {
                            return;
                        }

                        cruiseBtn = angular.element('<button type="button" class="btn btn-info btn-export"></button>');
                        cruiseBtn.append(angular.element('<i class="icon-left"></i>'));
                        cruiseBtn.append(angular.element('<span></span>').text(cruiseLink.title || 'Cruise Performance'));
                        cruiseBtn.on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            scope.$apply(function () { openCruisePerformanceModal(cruiseLink); });
                        });
                        toolbar.append(cruiseBtn);
                    };

                    scope.$watch('query', syncButton, true);

                    scope.$on('$destroy', function () {
                        removeButton();
                    });

                    element.css('display', 'none');

                    scope.$evalAsync(syncButton);
                }
            };
        }]);
}
